import { ref, reactive, watch, toRefs, computed } from "vue";
import GlobalServices from "../services/firebase/GlobalServices.js";
import i18n from "../i18n/index.js";
import store from "../store/index.js";
import Alert from "../utils/alert.js";
import { notyfError, notyfSuccess } from "../utils/notyf.js";

export default function () {
  const loading = ref(false);
  const data = ref([]);
  const error = ref(false);
  const getItemsObj       = ref({});
  const nextPageIsActive  = ref(false);


  watch(data, () => {
    store.commit("addContacts", [...data.value])
    //console.log("changed",store.getters._getBooks);
  })

  const user = computed(() => {
    return store.getters?._getCurrentUser || null;
  });

  const getItems = async (obj = {}) => {
    getItemsObj.value = obj;
    if(!obj.lastDocument) data.value = [];


    loading.value = true;
    return new Promise(async (resolve, reject) => {
      await GlobalServices.getItems('contacts', obj)
        .then((response) => {
          loading.value = false;
          if (response && !response?.error) {
              let items = response.items || [...response];
              data.value = [...data.value, ...items];
              
              obj.lastDocument = response.lastDocument;

              if(items.length > 0 && items.length < (obj.perPage || 20)){
                nextPageIsActive.value = false;
              }else{
                nextPageIsActive.value = true;
              }

              resolve(response); 
          }else{
            if(response?.error){
              error.value = response.error;
              reject(response.error);
            }else{
              const systemError = "Sistemden kaynaklanan bir hata oldu";
              if (response?.error){
                error.value = response.error;
                reject(response.error);
              }
              
              error.value = systemError;
              reject(systemError)
            }
          }
        })
        .catch((error) => {
          loading.value = false;
          error.value = error;
          reject(error);
        });
    });
  };


  const getItemsNextPage = async () => {
    if(!nextPageIsActive.value) return;
    loading.value = true;
    return new Promise(async (resolve, reject) => {
      await getItems({...getItemsObj.value, lastDocument: getItemsObj.value.lastDocument});
    });
  };

  const statsLoading = ref(false);
  const contactStats = ref({ total: 0, new: 0, processed: 0, completed: 0 });

  const fetchContactStats = async () => {
    statsLoading.value = true;
    try {
      const [totalRes, newRes, processedRes, completedRes] = await Promise.all([
        GlobalServices.getItems('contacts', { count: true }),
        GlobalServices.getItems('contacts', { count: true, filter: { contact_status: 'new' } }),
        GlobalServices.getItems('contacts', { count: true, filter: { contact_status: 'processed' } }),
        GlobalServices.getItems('contacts', { count: true, filter: { contact_status: 'completed' } }),
      ]);

      contactStats.value = {
        total: totalRes?.totalItems || 0,
        new: newRes?.totalItems || 0,
        processed: processedRes?.totalItems || 0,
        completed: completedRes?.totalItems || 0,
      };

      return contactStats.value;
    } catch (err) {
      error.value = err?.message || err;
      throw err;
    } finally {
      statsLoading.value = false;
    }
  };

  const searchItems = async (obj) => {
    loading.value = true;
    return new Promise(async (resolve, reject) => {
      await GlobalServices.searchItems('contacts', obj)
        .then((response) => {
          loading.value = false;
          if (response && !response?.error) {
            data.value =  response?.items || [...response];
            resolve(response); 
        }else{
          if(response?.error){
            error.value = response.error;
            reject(response.error);
          }else{
            const systemError = "Sistemden kaynaklanan bir hata oldu";
            if (response?.error){
              error.value = response.error;
              reject(response.error);
            }
            
            error.value = systemError;
            reject(systemError)
          }
        }
        })
        .catch((error) => {
          loading.value = false;
          error.value = error;
          reject(error);
        });
    });
  };

  const getItem = async (obj, options = {}) => {
    loading.value = true;
    return new Promise(async (resolve, reject) => {
      await GlobalServices.getItem('contacts', obj, options)
        .then((response) => {
          loading.value = false;
          if (response && !response?.error) {
            //data = {...response};
            resolve({...response}); 
        }else{
          if(response?.error){
            error.value = response.error;
            reject(response.error);
          }else{
            const systemError = "Sistemden kaynaklanan bir hata oldu";
            if (response?.error){
              error.value = response.error;
              reject(response.error);
            }
            
            error.value = systemError;
            reject(systemError)
          }
        }
        })
        .catch((error) => {
          loading.value = false;
          error.value = error;
          reject(error);
        });
    });
  };

  // add new user
  const addItem = async (obj) => {
    loading.value = true;
    return new Promise(async (resolve, reject) => {

      await GlobalServices.addItem('contacts', { ...obj, createdBy: user?.value?.id || null })
        .then((response) => {
          loading.value = false;
          if (response && !response?.error) {
            addStoreData(response)
            resolve({ ...response });
          }else{
            if(response?.error){
              error.value = response.error;
              reject(response.error);
            }else{
              const systemError = "Sistemden kaynaklanan bir hata oldu";
              if (response?.error){
                error.value = response.error;
                reject(response.error);
              }
              
              error.value = systemError;
              reject(systemError)
            }
          }

        })
        .catch((error) => {
          loading.value = false;
          error.value = error;
          reject(error);
        });
    });
  };

  const updateItem = async (obj) => {
    loading.value = true;
    return new Promise(async (resolve, reject) => {

      await GlobalServices.updateItem('contacts', { ...obj, createdBy: user?.value?.id || null })
        .then((response) => {
          loading.value = false;

          if (response && !response?.error) {
            //data = [...response]
            updateStoreData(response)

            resolve({ ...response });
          }else{
            if(response?.error){
              error.value = response.error;
              reject(response.error);
            }else{
              const systemError = "Sistemden kaynaklanan bir hata oldu";
              if (response?.error){
                error.value = response.error;
                reject(response.error);
              }
              
              error.value = systemError;
              reject(systemError)
            }
          }

        })
        .catch((error) => {
          loading.value = false;
          error.value = error;
          reject(error);
        });
    });
  };


  const confirmDelete = (obj) => {
    const t = i18n.global.t;
    return new Promise(async (resolve, reject) => {
      Alert.showPrompt(t('contacts.notifications.deleteConfirm')).then((res) => {
        if (!res.isConfirmed) {
          notyfError(t('contacts.notifications.deleteCancelled'));
        } else {
          deleteItem(obj)
            .then((res) => resolve(res))
            .catch((err) => reject(err));
        }
      });
    });
  };

  const deleteItem = async (obj) => {
   
    loading.value = true;
    return new Promise(async (resolve, reject) => {
      await GlobalServices.deleteItem('contacts', obj)
        .then((response) => {
          loading.value = false;

          if (response && !response?.error) {
            notyfSuccess(i18n.global.t('contacts.notifications.deleteSuccess'))
            deleteStoreData(obj.id)
            resolve([...data.value.filter((i) => i.id != obj.id)]);
          }else{
            if(response?.error){
              error.value = response.error;
              reject(response.error);
            }else{
              const systemError = "Sistemden kaynaklanan bir hata oldu";
              if (response?.error){
                error.value = response.error;
                reject(response.error);
              }
              
              error.value = systemError;
              reject(systemError)
            }
          }

        })
        .catch((error) => {
          loading.value = false;
          error.value = error;
          reject(error);
        });
    });
  };

  
  const addStoreData = (item) => {
    data.value = [...getStoreData.value, item]
  } 


  const updateStoreData = (item) => {
    const index = getStoreData.value.map(i => i.id).indexOf(item.id);
    getStoreData.value[index] = item;
    data.value = getStoreData.value;
  }

  const deleteStoreData = (id) => {
    data.value = [...getStoreData.value.filter((i) => i.id != id)];
  }

  const getStoreData = computed(() => {
    return store.getters._getContacts;
  })

  return {
    error,
    loading,
    data,
    getStoreData,
    getItem,
    searchItems,
    getItems,
    addItem,
    updateItem,
    confirmDelete,
    deleteItem,
    getItemsNextPage,
    nextPageIsActive,
    statsLoading,
    contactStats,
    fetchContactStats,
  };
}
